import moment from 'moment';
import { formatMonthTitleCN, isGreaterChinaLocale } from '@marriott/shared/mi-helper-utils';
import { checkLocaleToAddYears } from '../../../utils/DateUtils';
import { convertToUpperCase } from '../../../../../../utils';
import type { SingleDateHeaderProps } from './singleDateHeader.types';
import { getLocalizedDate } from '@marriott/mi-ui-library';
import { FLEXIBLE_FORMAT_YEAR_MONTH } from '../../../../../../constants/Calendar.constant';
import { formatDateStringBasedOnLocale } from '../../../../../../utils/src/helper';
import { AR_LOCALE, HI_LOCALE } from '../../../../../../modules/constants/Calendar.constants';

export const getDateText = (
  monthSelected: SingleDateHeaderProps['monthSelected'],
  yearSelected: SingleDateHeaderProps['yearSelected'],
  currentLocale: string,
  selectAMonth: string,
  dateFormatInput?: string
): string => {
  if (!monthSelected) {
    return convertToUpperCase(selectAMonth, currentLocale);
  }

  if (isGreaterChinaLocale(currentLocale)) {
    return formatMonthTitleCN({ month: monthSelected - 1, year: yearSelected });
  }

  const updatedYearValue = checkLocaleToAddYears(currentLocale, Number(yearSelected));
  // Adding 1 as the default 'day' value since we only use month and year for flex date scenarios anyway
  const localizedDate = getLocalizedDate(
    moment(new Date(updatedYearValue ?? new Date().getFullYear(), monthSelected - 1, 1)),
    dateFormatInput ?? FLEXIBLE_FORMAT_YEAR_MONTH,
    currentLocale
  );
  let returnedDate = convertToUpperCase(localizedDate, currentLocale);
  returnedDate = formatDateStringBasedOnLocale(returnedDate);
  return returnedDate;
};
